import WebFormsContent from "./webFormsContent";

const WebForms = () => {
    return <WebFormsContent />;
};

export default WebForms;
